import { Link } from 'react-router-dom';
import { useSites, useContent } from '../api/queries.js';
import { SiteStatus } from '@waw/shared-types';
import './HomePage.css';

const SITE_META = {
  WAW_CASA: { city: 'Casablanca — Aïn Diab', tagline: 'Aïn Diab by night' },
  WAW_WAVE: { city: 'Témara', tagline: 'Surf & glisse' },
  WAW_FES: { city: 'Fès', tagline: 'Néons médina' },
  WAW_MARRAKECH: { city: 'Marrakech', tagline: 'Sunset arcade' },
  WAW_TANGER: { city: 'Tanger', tagline: 'Face au détroit' },
};

export default function HomePage() {
  const { data: sites, isLoading, isError } = useSites();
  const { data: content } = useContent();

  const heroTitle = content?.home_hero_title || 'Réservez votre moment WAW!';
  const heroSubtitle =
    content?.home_hero_subtitle ||
    'Parcs de loisirs, bowling, escape game et bien plus encore.';

  return (
    <>
      <section className="home-hero waw-pattern-bg">
        <div className="container">
          <h1 className="heading-display">{heroTitle}</h1>
          <p className="home-hero-sub">
            {heroSubtitle}
            <br />
            Choisissez votre <strong>parc WAW</strong> pour commencer.
          </p>
        </div>
      </section>

      <section className="container">
        {isLoading && (
          <div className="sites-grid">
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="card site-skeleton skeleton" />
            ))}
          </div>
        )}

        {isError && (
          <div className="home-error">
            <p>Impossible de charger les sites. Veuillez réessayer.</p>
          </div>
        )}

        {sites && (
          <div className="sites-grid">
            {sites.map((site) => {
              const isActive = site.status === SiteStatus.ACTIVE;
              const meta = SITE_META[site.code] || {};
              const city = site.city || meta.city || site.code;
              const tagline = site.tagline || meta.tagline || '';
              // Image réelle si définie via le CMS, sinon dégradé de secours (classe visuel-CODE).
              const visuelClass = `site-card-visuel${site.cardImageUrl ? '' : ` visuel-${site.code}`}`;
              const visuelStyle = site.cardImageUrl
                ? { backgroundImage: `url(${site.cardImageUrl})` }
                : undefined;

              if (isActive) {
                return (
                  <Link
                    key={site.code}
                    to={`/reserver/${site.code}`}
                    className="site-card site-card-active"
                  >
                    <div className={visuelClass} style={visuelStyle}>
                      <span className="site-card-visuel-text">{tagline}</span>
                    </div>
                    <span className="site-card-name">{site.displayName || site.name}</span>
                    <span className="site-card-city">{city}</span>
                    <span className="site-card-footer">
                      <span className="badge-active">
                        <span className="badge-dot" />
                        Ouvert
                      </span>
                      <span className="site-card-cta">Réserver &rarr;</span>
                    </span>
                  </Link>
                );
              }

              return (
                <div
                  key={site.code}
                  className="site-card site-card-soon"
                >
                  <div className={visuelClass} style={visuelStyle}>
                    <span className="site-card-visuel-text">{tagline}</span>
                  </div>
                  <span className="site-card-name">{site.displayName || site.name}</span>
                  <span className="site-card-city">{city}</span>
                  <span className="site-card-footer">
                    <span className="badge-soon">
                      <span className="badge-dot" />
                      Bientôt disponible
                    </span>
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </section>
    </>
  );
}
